import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { searchStore as searchStoreV1 } from 'owa-mail-search-store';
import { SearchSpellCheckerSuggestion } from 'owa-mail-search-view';
import { searchStore as searchStoreV2 } from 'owa-search';
import * as React from 'react';
import { SearchInContextFeedbackDialog, UserVoiceSearchTeam } from 'owa-search-diagnostics-view';
var SearchHeaderFirstRowContent = /** @class */ (function (_super) {
    tslib_1.__extends(SearchHeaderFirstRowContent, _super);
    function SearchHeaderFirstRowContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchStore = isMailFeatureEnabled('sea-commonSearchBox')
            ? searchStoreV2
            : searchStoreV1;
        return _this;
    }
    SearchHeaderFirstRowContent.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            isMailFeatureEnabled('sea-contextFeedback') && (React.createElement(SearchInContextFeedbackDialog, { cssClass: this.props.className, currentSearchQueryId: this.searchStore.currentSearchQueryId, userVoiceTeam: UserVoiceSearchTeam.MailSearch })),
            isMailFeatureEnabled('sea-spellingCorrectedSearch') && (React.createElement(SearchSpellCheckerSuggestion, { className: this.props.className }))));
    };
    SearchHeaderFirstRowContent = tslib_1.__decorate([
        observer
    ], SearchHeaderFirstRowContent);
    return SearchHeaderFirstRowContent;
}(React.Component));
export default SearchHeaderFirstRowContent;
//# sourceMappingURL=SearchHeaderFirstRowContent.js.map